'use client';

import type { ReactNode } from 'react';
import { logTrackingEvent } from '@/utils/tracking';
import type { TrackingEventObject } from '@/types/tracking';

type TrackingEventWrapperProps = {
  children: ReactNode;
  trackingEvent: TrackingEventObject;
};

export function TrackingEventWrapper({ children, trackingEvent }: TrackingEventWrapperProps) {
  return (
    <div className="contents" onClick={() => logTrackingEvent(trackingEvent)}>
      {children}
    </div>
  );
}
